import { err, ok } from "neverthrow";
import { match } from "ts-pattern";
import { mustBeDefined } from "./defined.js";
import { buildConflictError, buildInternalError, buildNotFoundError, } from "./error.js";
/**
 * Ensures that an array contains exactly the expected number of items.
 *
 * @param message
 * @returns
 */
export function mustHaveLength(length, message) {
    return (value) => value.length === length
        ? ok(value)
        : value.length === 0
            ? err(buildNotFoundError({ message }))
            : err(buildInternalError({ message }));
}
/**
 * Takes the first item from an array.
 */
export function takeFirst(message) {
    return (value) => ok(value.at(0)).andThen(mustBeDefined(message));
}
/**
 * Ensures an array does NOT have the specified length.
 * Returns semantically correct errors:
 *   • length 0 = NotFoundError
 *   • length 1 = ConflictError (e.g. duplicate)
 *   • any other = InternalError (unexpected count)
 */
export function mustNotHaveLength(forbiddenLength, message) {
    return (arr) => {
        if (arr.length !== forbiddenLength) {
            return ok(arr);
        }
        const error = match(arr.length)
            .with(0, () => message
            ? buildNotFoundError({ message })
            : buildNotFoundError({
                message: "Expected at least one item, but found none",
            }))
            .with(1, () => message
            ? buildConflictError({ message })
            : buildConflictError({
                message: "Expected zero or multiple items, but found exactly one",
            }))
            .otherwise(() => message
            ? buildInternalError({ message })
            : buildInternalError({
                message: `Array has unexpected length: ${String(arr.length)}`,
            }));
        return err(error);
    };
}
//# sourceMappingURL=array.js.map